var BTTO_SHARE_I18N = (function () {
  var lang = (document.documentElement.lang || 'de').slice(0, 2);
  var t = {
    de: { loading: 'Wird geladen …', share: 'Teilen', copied: 'Kopiert', copy: 'Link kopieren', failed: 'Teilen des Warenkorbs fehlgeschlagen. Bitte versuchen Sie es erneut.', restoring: 'Warenkorb wird wiederhergestellt …', restoreFailed: 'Der geteilte Warenkorb konnte nicht wiederhergestellt werden.' },
    en: { loading: 'Loading…', share: 'Share', copied: 'Copied', copy: 'Copy link', failed: 'Share cart failed. Please try again.', restoring: 'Restoring your cart…', restoreFailed: 'Shared cart could not be restored.' },
    fr: { loading: 'Chargement…', share: 'Partager', copied: 'Copié', copy: 'Copier le lien', failed: 'Le partage du panier a échoué. Veuillez réessayer.', restoring: 'Restauration de votre panier…', restoreFailed: "Le panier partagé n'a pas pu être restauré." }
  };
  return t[lang] || t.de;
})();

document.addEventListener('click', async function (event) {
  const shareBtn = event.target.closest('.btto-cart-share-btn');
  const closeBtn = event.target.closest('.btto-share-cart-modal__close');
  const overlay = event.target.closest('.btto-share-cart-modal__overlay');
  const copyBtn = event.target.closest('.btto-share-cart-copy');

  const modal = document.querySelector('.btto-share-cart-modal');
  const input = document.querySelector('.btto-share-cart-link');

  if (shareBtn) {
    shareBtn.disabled = true;
    shareBtn.textContent = BTTO_SHARE_I18N.loading;

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const saveResponse = await fetch('https://btto-share-cart.imichaelfsh.workers.dev/save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: cart.items.map(function (item) {
            return {
              id: item.variant_id,
              quantity: item.quantity,
              properties: item.properties || {}
            };
          })
        })
      });

      const data = await saveResponse.json();

      if (!data.success || !data.token) {
        throw new Error('Create share link failed');
      }

      input.value = window.location.origin + '/pages/cart?token=' + data.token;
      modal.hidden = false;
    } catch (error) {
      alert(BTTO_SHARE_I18N.failed);
      console.error(error);
    } finally {
      shareBtn.disabled = false;
      shareBtn.textContent = BTTO_SHARE_I18N.share;
    }
  }

  if (closeBtn || overlay) {
    modal.hidden = true;
  }

  if (copyBtn) {
    input.select();
    input.setSelectionRange(0, 99999);
    await navigator.clipboard.writeText(input.value);
    copyBtn.textContent = BTTO_SHARE_I18N.copied;
    setTimeout(function () {
      copyBtn.textContent = BTTO_SHARE_I18N.copy;
    }, 1500);
  }
});
document.addEventListener('DOMContentLoaded', async function () {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  if (!token) return;
  if (!window.location.pathname.includes('/pages/cart')) return;

  document.body.insertAdjacentHTML(
    'afterbegin',
    '<div class="btto-cart-restore-loading">' + BTTO_SHARE_I18N.restoring + '</div>'
  );

  try {
    const loadResponse = await fetch(
      'https://btto-share-cart.imichaelfsh.workers.dev/load?token=' + encodeURIComponent(token)
    );

    const data = await loadResponse.json();

    if (!data.items || !Array.isArray(data.items)) {
      throw new Error('Invalid shared cart');
    }

    await fetch('/cart/clear.js', {
      method: 'POST'
    });

    for (const item of data.items) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: item.id,
          quantity: item.quantity,
          properties: item.properties || {}
        })
      });
    }

    window.location.href = '/cart';
  } catch (error) {
    console.error(error);
    document.querySelector('.btto-cart-restore-loading').textContent =
      BTTO_SHARE_I18N.restoreFailed;
  }
});